import { Deserializable } from '../../protocols/deserializable';
import { Attachment } from '../../submissions/attachment';

export class MemberDeathRecordAttachment implements Deserializable {
  public id!: string;
  public deathRecordId!: number;
  public attachment!: Attachment;

  onDeserialize(): void {
    this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
  }
}
